import isGdprCheckboxEnabled from './is-gdpr-checkbox-enabled';
import isBuilderEnabled from './is-builder-enabled';

export default {
  isGdprCheckboxEnabled,
  isBuilderEnabled,
};
